import React from 'react';

import css from './FilterModal.module.css';
import { FormattedMessage } from 'react-intl';

function FilterFooter(props) {
  const { handleResetAll, onSetFilterModalOpen, totalItems } = props;
  return (
    <div className={css.filterFooter}>
      <button
        className={css.resetAllButton}
        type="button"
        onClick={() => {
          handleResetAll();
        }}
      >
        <FormattedMessage id="SearchFiltersMobile.resetAll" />
      </button>
      <button
        className={css.showResults}
        type="button"
        onClick={() => {
          onSetFilterModalOpen();
        }}
      >
        <FormattedMessage id="SearchPage.totalItems" values={{ totalItems }} />
      </button>
    </div>
  );
}

export default FilterFooter;
